import { QueryClient } from "@tanstack/react-query";
import { UnauthorizedError } from "./client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof UnauthorizedError) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
